import React, { useEffect } from "react"
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { Center, HStack, Text, Spinner, Container, useToast } from "@chakra-ui/react";

function getRedirectUrl({ origin, pageParams, customerId }) {
  if (origin === "accountmanagement") {
    return `/account-management${pageParams || ''}`;
  }
  if (origin === "management") {
    return `/management/quickbooks${pageParams || ''}`;
  }
  return `/client/${customerId}#qb`;
}

export const ClientQuickbooksLink = () => {
    const [searchParams] = useSearchParams();
    const toast = useToast();

    const customer_id = sessionStorage.getItem("customer_id");
    const code = searchParams.get("code");
    const realmId = searchParams.get("realmId");
    const error = searchParams.get("error");
    const errorDescription = searchParams.get("error_description");

    useEffect(() => {
      if (error) {
        let userMessage = "QuickBooks connection was cancelled or denied. No changes were made.";
        if (error !== "access_denied" && errorDescription) {
          userMessage = errorDescription;
        }
        toast({
          title: "QuickBooks Connection Cancelled",
          description: userMessage,
          status: "error",
          duration: 10000,
          isClosable: true,
        });
        // Optionally redirect after showing error
        setTimeout(() => {
          const origin = sessionStorage.getItem("qb_connect_origin");
          const pageParams = sessionStorage.getItem("qb_connect_page_params");
          window.location.href = getRedirectUrl({ origin, pageParams, customerId: customer_id });
        }, 2000);
        return;
      }
      if (code && realmId) {
        axios
          .post(`/api/v2/client_link_quickbooks/`,
              {
                customer_id: customer_id,
                code: code,
                realm_id: realmId
              },
              {headers: {'Content-Type': 'application/json'}},
              {withCredentials: true})
          .then(() => {
            const origin = sessionStorage.getItem("qb_connect_origin");
            const pageParams = sessionStorage.getItem("qb_connect_page_params");
            window.location.href = getRedirectUrl({ origin, pageParams, customerId: customer_id });
          })
          .catch((err) => {
            toast({
              title: "QuickBooks Connection Failed",
              description: err?.response?.data?.error || "Failed to complete QuickBooks connection.",
              status: "error",
              duration: 10000,
              isClosable: true,
            });
          });
        return;
      }
      // If neither error nor code/realmId, show a generic error
      toast({
        title: "QuickBooks Connection Error",
        description: "Unexpected QuickBooks OAuth response.",
        status: "error",
        duration: 10000,
        isClosable: true,
      });
      setTimeout(() => {
        const origin = sessionStorage.getItem("qb_connect_origin");
        const pageParams = sessionStorage.getItem("qb_connect_page_params");
        window.location.href = getRedirectUrl({ origin, pageParams, customerId: customer_id });
      }, 2000);
    }, [customer_id, code, realmId, error, errorDescription, toast]);

    return (
      <Container maxW="100%" height='calc(100vh - 80px)' bg="brand.50">
          <Center pt="8">
              <HStack>
                  <Text>Redirecting, please wait. &nbsp; &nbsp;</Text>
                  <Spinner color="brand.600"/>
              </HStack>
          </Center>
      </Container>
    );
}
